import React, { Fragment, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { DialogModal } from ".";
import { hideDialog, showDialog } from "../../appRedux/actions/common";
import { deleteSubscription, getSubscriptionsList } from "../../appRedux/actions/subscriptions";

const BodyView = ({ info }) => {
  const dispatch = useDispatch();
  const queryInfo = useSelector((state) => state.subscriptions.queryInfo);

  return (
    <Fragment>
      <div className="form-header text-center">
        <h3>Remove Subscription</h3>
        <p>Are you sure you want to remove this subscription?</p>
      </div>
      <div className="modal-btn delete-action">
        <div className="row">
          <div className="col-6">
            <button
              onClick={() => dispatch(hideDialog())}
              className="btn btn-secondary continue-btn"
              style={{ width: "100%", borderRadius: "6px" }}
            >
              Cancel
            </button>
          </div>
          <div className="col-6">
            <button
              onClick={() => {
                dispatch(deleteSubscription({ id: info._id }))
                  .then(() => {
                    dispatch(getSubscriptionsList(queryInfo)).catch(() => {});
                    dispatch(hideDialog());
                  })
                  .catch(() => {});
              }}
              className="btn btn-danger cancel-btn"
              style={{ width: "100%", borderRadius: "6px" }}
            >
              Remove
            </button>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

function DeleteModalComponent({ info }) {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const dialog = useSelector((state) => state.common.dialog);

  useEffect(() => {
    if (!dialog) setOpen(dialog);
  }, [dialog]);

  return (
    <Fragment>
      <button
        className="dropdown-item"
        onClick={() => {
          setOpen(true);
          dispatch(showDialog({ title: "", hideHeader: true }));
        }}
        key="delete_subscription"
      >
        <i className="fa fa-trash m-r-5" /> Remove
      </button>
      {open && (
        <DialogModal bodyView={<BodyView info={info} />} />
      )}
    </Fragment>
  );
}

export default DeleteModalComponent;
